import { css } from 'styled-components';

export const CommonContainerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;